import { render, staticRenderFns } from "./SelectionedGoodsList.vue?vue&type=template&id=e9641870&scoped=true"
import script from "./SelectionedGoodsList.vue?vue&type=script&lang=js"
export * from "./SelectionedGoodsList.vue?vue&type=script&lang=js"
import style0 from "./SelectionedGoodsList.vue?vue&type=style&index=0&id=e9641870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9641870",
  null
  
)

export default component.exports